export const getImageUrl = (url?: string | null): string => {
  if (!url) {
    return 'https://via.placeholder.com/800x400?text=No+Image';
  }

  if (url.startsWith('http')) {
    return url;
  }

  // Get base URL from environment or default
  // Note: We need the server root, not the API root (/api/v1)
  // Assuming API_URL is like http://localhost:3200/api/v1
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3200/api/v1';
  
  try {
    const urlObj = new URL(apiUrl);
    const origin = urlObj.origin; // http://localhost:3200
    
    // Ensure url starts with /
    const path = url.startsWith('/') ? url : `/${url}`;
    
    return `${origin}${path}`;
  } catch (e) {
    return url;
  }
};
